import { render, staticRenderFns } from "./ReportWarranty.vue?vue&type=template&id=2f70ab70&scoped=true"
import script from "./ReportWarranty.vue?vue&type=script&lang=js"
export * from "./ReportWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70ab70",
  null
  
)

export default component.exports